import React from "react"
import firebase from "./firebase"

const FirebaseContext = React.createContext(null)

export const withFirebase = Component => props => <Component {...props} firebase={firebase} />

export default FirebaseContext
